import { FC, memo } from "react";
import Box from "@mui/material/Box";
import Stack from "@mui/material/Stack";
import Typography from "@mui/material/Typography";
import type { ErrorOverlayProps } from "../types";

const DEFAULT_ERROR_TITLE = "Error loading data";
const DEFAULT_ERROR_MESSAGE = "An unexpected error occurred";

/**
 * Default error state overlay for DataTable.
 * Shown when an error occurs during data fetching.
 */
export const ErrorOverlay: FC<ErrorOverlayProps> = memo(function ErrorOverlay({
  error,
}) {
  const errorMessage = error?.message || DEFAULT_ERROR_MESSAGE;

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      height="100%"
      minHeight={200}
      bgcolor="#edeff1"
    >
      <Stack spacing={1} alignItems="center">
        <Typography variant="h5" color="error">
          {DEFAULT_ERROR_TITLE}
        </Typography>
        <Typography variant="body2" color="text.secondary">
          {errorMessage}
        </Typography>
      </Stack>
    </Box>
  );
});
